import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { capitalize } from '../../../utilities/helperUtility';
import './index.css';

export default class TableComponent extends Component {
  parseTag(list, props) {
    const name = `${list.key}_${props.header}`;

    const style = {
      ...this.props.style,
      ...props.attrs[list.key].style,
    };

    switch (props.type) {
      case 'number':
        const { max = null } = props.attrs[list.key];

        return (
          <input
            {...props.attrs[list.key]}
            min={0}
            disabled={!max}
            name={name}
            type="number"
            style={style}
            onInput={props.onChange.bind(this)}
            defaultValue={this.props.items[list.key] ? this.props.items[list.key].quantity : 0}
          />
        );
      case 'button':
        return (
          <button {...props.attrs[list.key]} name={name} style={style} onClick={props.onClick.bind(this)}>
            {props.content}
          </button>
        );
    }
  }

  columnHead() {
    return this.props.columns.headers.map((header, i) => (
      <th style={{ minWidth: '45px' }} key={header + i}>
        <div>{capitalize(header)}</div>
      </th>
    ));
  }

  columnBody(list) {
    return this.props.columns.headers.map((header, i) => <td key={list[header] + list.key + i}>{list[header]}</td>);
  }

  extraColumnsHead() {
    return this.props.extraColumns.map(data => (
      <th key={data.header}>
        <div>{capitalize(data.header)}</div>
      </th>
    ));
  }

  extraColumnsBody(list) {
    return this.props.extraColumns.map((data, i) => (
      <th key={data.header + list.key + i}>{this.parseTag(list, data)}</th>
    ));
  }

  render() {
    const {
      columns: { lists },
      hideHead,
      className,
      columnReverse,
    } = this.props;

    return (
      <section className="fixed-thead" style={hideHead ? { paddingTop: '0' } : {}}>
        <div className="table-container">
          <table className={`pure-table pure-form center fluid ${className}`}>
            <thead style={hideHead ? { display: 'none' } : {}}>
              <tr>
                {columnReverse && this.extraColumnsHead()}
                {this.columnHead()}
                {!columnReverse && this.extraColumnsHead()}
              </tr>
            </thead>
            <tbody>
              {lists.map((list, i ) => (
                <tr key={list.key + i}>
                  {columnReverse && this.extraColumnsBody(list)}
                  {this.columnBody(list)}
                  {!columnReverse && this.extraColumnsBody(list)}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>
    );
  }
}

TableComponent.propTypes = {
  columns: PropTypes.shape({
    headers: PropTypes.array.isRequired,
    lists: PropTypes.array.isRequired,
  }),
  extraColumns: PropTypes.arrayOf(
    PropTypes.shape({
      quantity: PropTypes.string,
      type: PropTypes.string.isRequired,
      onChange: PropTypes.func,
    }),
  ),
};
